<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>単価情報</mat-card-title>
    </mat-card-header>
    <form [formGroup]="slideTankaRegisterInfoForm">
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field [appearance]="appearanceModeBet"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                <mat-label>適用開始年月</mat-label>
                <input matInput id="applyStartyearmonth" [disabled]="true"
                    [value]="slideTankaRegisterInfoForm.get('applyStartyearmonth').value | dateYmStringSg"
                    class="font-color-display-only" />
            </mat-form-field>
            <mat-form-field [appearance]="appearanceModeBet"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                <mat-label>適用終了年月</mat-label>
                <input matInput id="applyEndyearmonth" [disabled]="true"
                    [value]="slideTankaRegisterInfoForm.get('applyEndyearmonth').value | dateYmStringSg"
                    class="font-color-display-only" />
            </mat-form-field>
            <mat-form-field [appearance]="appearanceMode"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                <mat-label>スライド調整単価</mat-label>
                <input matInput formControlName="slideadjustmentunitprice" style="text-align: right;"
                    (blur)="onBlurNumber()" [maxlength]="numberCommaMaxLength" class="font-color-display-only" />
                <span matSuffix class="ml5px font-color-display-only">円</span>
            </mat-form-field>
        </div>
        <!-- 表示モードが登録モードのとき非表示 -->
        <div *ngIf="mode !== 'create'">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field [appearance]="appearanceMode"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                    <mat-label>適用開始年月日</mat-label>
                    <input matInput id="applyStartDate" class="font-color-display-only" [disabled]="true"
                        [value]="slideTankaRegisterInfoForm.get('applyStartDate').value | dateString" />
                </mat-form-field>
                <mat-form-field [appearance]="appearanceMode"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                    <mat-label>適用終了年月日</mat-label>
                    <input matInput id="applyEndDate" class="font-color-display-only" [disabled]="true"
                        [value]="slideTankaRegisterInfoForm.get('applyEndDate').value | dateString" />
                </mat-form-field>
                <mat-form-field [appearance]="appearanceMode"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                    <mat-label>消費税率</mat-label>
                    <input matInput formControlName=brdCode autocomplete="off" style="text-align: right;"
                        class="font-color-display-only" />
                    <span matSuffix class="tw-ml-[5px] font-color-display-only">％</span>
                </mat-form-field>
                <mat-form-field [appearance]="appearanceMode"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-lg:max-w-[full]">
                    <mat-label>旧新区分</mat-label>
                    <input matInput formControlName="oldnewdivision" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
            </div>
        </div>
        <!-- スライド算定諸元登録フラグがtrueのとき結果を表示 -->
        <div *ngIf="slideadjustmentunitpriceBasicInfo.slidecalculationelementsRegFlg "
            id="slidecalculationelementstable">
            <mat-card class="cur-card">
                <h2> 算定諸元情報</h2>
                <!-- formArrayのitemsから、tableを作成する -->
                <mat-card-content class="mat-card-style-search-kc-result">
                    <div class="table-responsive">
                        <!-- formArrayの値を表示 -->
                        <table mat-table [dataSource]="items.controls" class="border-bottom-double"
                            style="width:50%;margin-top:10px;margin-left:20px">
                            <ng-container matColumnDef="slidecalculationelementsItemname">
                                <th mat-header-cell *matHeaderCellDef> 項目 </th>
                                <td mat-cell *matCellDef="let item">
                                    {{item.get('slidecalculationelementsItemname').value}} </td>
                            </ng-container>
                            <ng-container matColumnDef="slidecalculationelementsInfo">
                                <th mat-header-cell *matHeaderCellDef> 項目値 </th>
                                <div formArrayName="items" *ngFor="let item of items.controls; let i = index">
                                    <td mat-cell *matCellDef="let item; let i = index" [formGroupName]="i">
                                        <input matInput formControlName="slidecalculationelementsInfo"
                                            (paste)="onInput($event, i)" autocomplete="off" />
                                    </td>
                                </div>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true;"></tr>
                            <tr mat-row *matRowDef="let item; columns: displayedColumnsCol"></tr>
                        </table>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </form>
    <mat-card-actions class="btn_area_right">
        <div class="tw-flex tw-flex-col tw-box-border tw-justify-end tw-items-end tw-content-end">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <button *ngIf="isRegistVisible" type="submit" (click)="onClickRegistration()" mat-raised-button
                    color="primary" class="btn" [disabled]="parentForm.invalid">登録</button>
                <button *ngIf="isDeleteVisible" type="submit" (click)="onClickDelete()" mat-raised-button
                    color="primary" class="btn">取消</button>
                <button *ngIf="isApproveVisible" type="submit" (click)="onClickApproval()" mat-raised-button
                    color="primary" class="btn">承認</button>
            </div>
            <div>
                <button type="submit" mat-raised-button color="primary" class="btn" (click)="goToPrevious()">戻る</button>
            </div>
        </div>
    </mat-card-actions>
</mat-card>